/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/dot-notation */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslatorService } from './translator.service';
import { LoadingController, ModalController, NavController, Platform } from '@ionic/angular';
import { getAuth, sendSignInLinkToEmail } from 'firebase/auth';
import { ResultshistoryComponent } from './components/resultshistory/resultshistory.component';
import { ExamService } from './exam.service';
import { GenericpopupComponent } from './components/genericpopup/genericpopup.component';
import { SwitchuserComponent } from './components/switchuser/switchuser.component';
import { getPlatforms } from '@ionic/angular';
import { isPlatform } from '@ionic/angular';
import { environment } from 'src/environments/environment.prod';
import { DatePipe } from '@angular/common';


const actionCodeSettings = {
  // URL you want to redirect back to. The domain (www.example.com) for this
  // URL must be in the authorized domains list in the Firebase Console.
  //url: 'https://genialii.firebase.com/tabs/tab1',
  url: 'https://genialii.web.app/tabs/tab1',
  //url:'http://localhost:8100/tabs/tab1',
  // This must be true.
  handleCodeInApp: true
};
const USER_DATA_COMPLETE = 0;
const USER_DATA_INCOMPLETE = 1;

export class KidData {
  public kidname = '';
  public avataridx = -1;
  public class = -1;
}
export class TestData {
  public testname = '';
  public langid = -1;
  public class = -1;
  public testid = -1;
  public teacherpath = '';
  public teachername = '';
  public teacherschool = '';
  public resultsavailable = false;
  public dateAdded = undefined;
  public materie = 3; //default materie generala
  public testconfirmed = false;
  public isCompetition = false;
}
export class CompetitionData {
  public year;
  public yearidx;
  public etapaidx;
  public etape;
  public langid;
}
export class UserData {
  public uid = '';
  public token = '';
  public email = '';
  public accountType = '';
  public judet = '';
  public judetid = -1;
  public localitate = '';
  public localitateid = -1;
  public unitate = '';
  public unitateid = -1;
  public confirmed = false;
  public name = '';
  public localUser = false;
  public languageid = 0;
  public language = '';
  public country = '';
  public countryid = -1;
  public lastUsedMember = -1;
}

@Injectable({
  providedIn: 'root'
})

export class LoginService {
  public componentRef;
  public languagePath = '';
  public counterOverlay = 0;
  public userAccount: UserData = new UserData();
  public activeUser = null;
  public kids: Array<KidData> = [];
  public teacherTests: Array<TestData> = [];
  public studentTests: Array<TestData> = [];
  public studentResults;
  public customPathParams = {};
  public customPathParsed = false;
  public flagsPath = [];
  public allTests = null;
  public allCompetitionStructure = null;
  public allCompetitionResults = [];
  public isAdmin = false;

  public isDesktop = true;
  public customPath = '';
  public cacheTest = {testData:{testname:"", langid:"", class:"" , shortval:"", materie:""}, questionsdata:{q:[]}};
  public dataClass = [{ id: 0, name: 'Gradinita I', shortval: '' }, { id: 1, name: 'Gradinita II', shortval: '' },
  { id: 2, name: 'Gradinita III', shortval: '' }, { id: 3, name: 'Clasa pregatitoare', shortval: '' }, { id: 4, name: 'Clasa I', shortval: '' },
  { id: 5, name: 'Clasa a II-a', shortval: '' }, { id: 6, name: 'Clasa a III-a', shortval: '' },
  { id: 7, name: 'Clasa a IV-a', shortval: '' }, { id: 8, name: 'Clasa a V-a', shortval: '' },
  { id: 9, name: 'Clasa a VI-a', shortval: '' }, { id: 10, name: 'Clasa a VII-a', shortval: '' },
  { id: 11, name: 'Clasa a VIII-a', shortval: '' }];
  public dataClassHTML = [{ id: 0, name: '<b>Gradinita I</b>', shortval: '' }, { id: 1, name: '<b>Gradinita II</b>', shortval: '' },
  { id: 2, name: '<b>Gradinita III</b>', shortval: '' }, { id: 3, name: '<b>Clasa <br>pregatitoare</b>', shortval: '' }, { id: 4, name: '<b>Clasa I</b>', shortval: '' },
  { id: 5, name: '<b>Clasa a II-a</b>', shortval: '' }, { id: 6, name: '<b>Clasa a III-a</b>', shortval: '' },
  { id: 7, name: '<b>Clasa a IV-a</b>', shortval: '' }, { id: 8, name: '<b>Clasa a V-a</b>', shortval: '' },
  { id: 9, name: '<b>Clasa a VI-a</b>', shortval: '' }, { id: 10, name: '<b>Clasa a VII-a</b>', shortval: '' },
  { id: 11, name: '<b>Clasa a VIII-a</b>', shortval: '' }, { id: 12, name: '', shortval: '' }];

  public datalanguages = [{ id: 0, name: 'Romana', shortval: 'ro' }, { id: 1, name: 'English', shortval: 'uk' },
  { id: 2, name: 'Magyar', shortval: 'hu' }, { id: 3, name: 'PDF', shortval: 'pdf' }];
  public dataMaterie = [{ id: 0, name: 'LIMBĂ ŞI COMUNICARE', shortval: 'lc' }, { id: 1, name: 'OM ŞI SOCIETATE', shortval: 'os' }, { id: 2, name: 'MATEMATICĂ ȘI STIINȚE', shortval: 'sci' },
  { id: 3, name: 'ESTETIC ŞI CREATIV', shortval: 'ec' }, { id: 4, name: '', shortval: 'epdf' }];
  private loadingAsset;
  private loadingAssetStatus = '';


  constructor(private plt: Platform, private http: HttpClient, public translator: TranslatorService, public loadingController: LoadingController,
    public navCtrl: NavController, public modalCtrl: ModalController, public examService: ExamService, public translatorService: TranslatorService, private datePipe: DatePipe) {
    translator.setLoginService(this);
    this.isDesktop = plt.width() > 820;
  }
  public setAppRef(ref) {
    this.componentRef = ref;
    for (const flag in this.datalanguages) {
      if (Object.hasOwnProperty.call(this.datalanguages, flag)) {
        this.flagsPath.push('./assets/flags/' + this.datalanguages[flag].shortval + '.png');
      }
    }
  }

  public logout() {
    const auth = getAuth();
    auth.signOut();
    this.activeUser = null;
    window.localStorage.setItem('emailForSignIn', '');
    this.navCtrl.navigateRoot('/tabs/tab4');
  }

  public sendEmailLink(email) {
    const auth = getAuth();
    sendSignInLinkToEmail(auth, email, actionCodeSettings)
      .then(() => {
        window.localStorage.setItem('emailForSignIn', email);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ...
      });
  }
  public async grabdata(path) {
    const httpOptions = {
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
        // eslint-disable-next-line quote-props, @typescript-eslint/naming-convention
        'Authorization': environment.extraApiKey
      })
    };
    this.showLoadingOverlay('grabdata');
    return new Promise(resolve => {
      const localhostlink = 'https://europe-west3-genialii.cloudfunctions.net/retrievedata?path=' + path;
      this.http
        .get(localhostlink, httpOptions)
        .subscribe(async (data: any) => {
          this.hideLoadingOverlay('grabData');
          resolve(data);
        });
    });
  }

  public async updatedata(path, vals) {
    this.showLoadingOverlay('updatedata');
    const httpOptions = {
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
        // eslint-disable-next-line quote-props, @typescript-eslint/naming-convention
        'Authorization': environment.extraApiKey
      })
    };
    return new Promise(resolve => {
      let explodestring = '';
      // eslint-disable-next-line guard-for-in
      for (const key in vals) {
        const item = key + '|_|' + vals[key];
        explodestring += item + '*_*';
      }
      const localhostlink = 'https://europe-west3-genialii.cloudfunctions.net/updatedata?path=' + path + '&vals=' + explodestring;
      this.http
        .get(localhostlink, httpOptions)
        .subscribe(async (data: any) => {
          this.hideLoadingOverlay();
          resolve(data);
        });
    });
  }

  public async showLoadingOverlay(path = '') {
    //console.log('showLoadingOverlay', path);
    this.counterOverlay++;
    await this.checkOverlay('add', path);

  }
  public async hideLoadingOverlay(path = '') {
    //console.log('hideLoadingOverlay', path);
    await this.delay(300);
    this.counterOverlay--;
    this.checkOverlay('substract', path);
  }
  public delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  public async userAuthenticated() {
    const uid = this.activeUser.auth.currentUser.uid;
    console.log(uid);
    if (uid === 'S7rTDg8xL3hEfhG3d7yv4nPqKzP2') {
      // this.isAdmin = true;
    }
    console.log(this.isAdmin);
    const path = 'users/' + uid + '/accountdata';
    let userDataStatus = -1;
    await this.grabdata(path).then((data: any) => {
      if (data !== 'fail') {
        if (data.data != null) {
          userDataStatus = USER_DATA_COMPLETE;
          this.userAccount.uid = this.activeUser.auth.currentUser.uid;
          this.userAccount.email = this.activeUser.email;
          this.userAccount.token = this.activeUser.accessToken;
          this.userAccount.judet = data.data.judet;
          this.userAccount.judetid = data.data.judetid;
          this.userAccount.localitate = data.data.localitate;
          this.userAccount.localitateid = data.data.localitateid;
          this.userAccount.accountType = data.data.accountType;
          this.userAccount.confirmed = data.data.confirmed;
          this.userAccount.name = data.name;
          this.userAccount.localUser = data.data.localUser;
          this.userAccount.languageid = data.data.languageid;
          this.userAccount.language = data.data.language;
          this.userAccount.country = data.data.country;
          this.userAccount.countryid = data.data.countryid;
          this.userAccount.unitate = data.data.unitate;
          this.userAccount.unitateid = data.data.unitateid;
          this.userAccount.name = data.data.name;
          this.userAccount.lastUsedMember = data.data.lastUsedMember;
          if (data.data.judet === undefined || data.data.judetid === undefined || data.data.localitate === undefined ||
            data.data.localitateid === undefined || data.data.accountType === undefined) {
            userDataStatus = USER_DATA_INCOMPLETE;
            this.userAccount.confirmed = false;
          }
          else {
            this.userAccount.confirmed = true;
          }
        }
        else {
          userDataStatus = USER_DATA_INCOMPLETE;
        }
      }
      else {
        userDataStatus = USER_DATA_INCOMPLETE;
      }
      if (userDataStatus === USER_DATA_COMPLETE) {
        if (this.userAccount.accountType === 'parent') {
          this.grabKids();
        }
        else {
          this.grabTeacherTests();
        }
      }
      else if (userDataStatus === USER_DATA_INCOMPLETE) {
        if (this.customPath.length > 0) {
          this.parseCustomPath();
        }
        else {
          this.navCtrl.navigateForward('tabs/tab1');
        }
      }
    });
  }

  public async parseCustomPath() {
    if (this.customPathParsed) {
      return;
    }
    this.customPathParsed = true;
    const vals = this.customPath.split('&');
    vals.splice(0, 1);
    this.customPathParams = {};
    // eslint-disable-next-line prefer-const
    for (const item in vals) {
      if (Object.prototype.hasOwnProperty.call(vals, item)) {
        const param = vals[item].split('=');
        param[1] = param[1].replace('%20', ' ');
        this.customPathParams[param[0]] = param[1];
      }
    }
    // eslint-disable-next-line @typescript-eslint/dot-notation
    if (this.customPathParams['viewresults']) {
      const path = 'users/' + this.customPathParams['userid'] + '/kids/' + this.customPathParams['kidid'] + '/testresults/' +
        this.customPathParams['teacherpath'] + '/' + this.customPathParams['lang'] + '/' +
        this.customPathParams['class'] + '/' + this.customPathParams['testid'];
      await this.grabdata(path).then(async (data: any) => {
        const resultsForTest = data.data;
        const pathteststructure = 'tests/structure/' + this.customPathParams['lang'] + '/' +
          this.customPathParams['class'] + '/' + this.customPathParams['teacherpath'] + '/tests/' + this.customPathParams['testid'];
        await this.grabdata(pathteststructure).then((datastructure: any) => {
          const pathtest = 'tests/content/' + this.customPathParams['lang'] + '/' +
            this.customPathParams['class'] + '/' + this.customPathParams['teacherpath'] + '/tests/' + this.customPathParams['testid'];
          this.examService.testdata = {
            class: this.customPathParams['class'], langid: this.customPathParams['lang'], resultsavailable: true, dateAdded: '',
            teachername: '', teacherpath: this.customPathParams['teacherpath'], teacherschool: '',
            testid: this.customPathParams['testid'], testname: datastructure.data.title, materie: this.customPathParams['materie'],
            testconfirmed: true, isCompetition: false
          };
          this.modalCtrl.create({
            component: ResultshistoryComponent,
            cssClass: 'modal-fullscreen',
            componentProps: {
              sessionResultData: resultsForTest, lang: this.customPathParams['lang'],
              class: this.customPathParams['class'], teacherpath: this.customPathParams['teacherpath'],
              testid: this.customPathParams['testid'], userid: this.customPathParams['userid'], isShowCase: true,
              testname: datastructure.data.title, kidname: this.customPathParams['kidname'],
              parentname: this.customPathParams['parentname']
            },
            backdropDismiss: false
          }).then(modalEl => {
            modalEl.present();
            modalEl.onDidDismiss().then(async result => {
              if (result.data && result.data !== -1) {
                this.examService.setSessionResultData(result.data);
                this.examService.grabTest(pathtest, this);
              }
              else if (+result.data === -1) {
                if (this.activeUser) {
                  this.navCtrl.navigateRoot('tabs/tab1');
                }
                else {
                  this.navCtrl.navigateRoot('tabs/tab4');
                }
              }
            });
          });
        });
      });
      return;

    }
    else if (this.customPathParams['viewtest']) {
      const testtitle = this.customPathParams['testtitle'].replace('%20', ' ');

      const testdefpath = '/tests/structure/' + this.datalanguages[this.customPathParams['lang']].shortval +
        '/' + this.customPathParams['class'] + '/' + this.customPathParams['teacherpath'] + '/tests/' + this.customPathParams['testid'];
      await this.grabdata(testdefpath).then((data: any) => {
        if (data.data && !!data.data.testconfirmed === true) {
          const path = 'tests/content/' + this.datalanguages[this.customPathParams['lang']].shortval +
            '/' + this.customPathParams['class'] + '/' + this.customPathParams['teacherpath'] + '/tests/' + this.customPathParams['testid'];
          this.examService.setSessionResultData(null);
          this.examService.testdata = {
            class: this.customPathParams['class'],
            langid: this.customPathParams['lang'],
            resultsavailable: null, teachername: '',
            dateAdded: '',
            teacherpath: this.customPathParams['teacherpath'],
            teacherschool: '', testid: this.customPathParams['testid'],
            testname: testtitle,
            materie: this.customPathParams['materie'],
            testconfirmed: true,
            isCompetition: false
          };
          if (this.userAccount.accountType === 'parent') {
            if (this.kids.length === 0) {
              const buttongroup = [{ label: this.translator.translate('idx', '*Sustine testul'), action: 1 }, { label: this.translator.translate('idx', '*Anuleaza'), action: 0 }];
              const titlelabel = this.translator.translate('idx', '*Atentionare!');
              const message = this.translator.translate
                ('idx', '*<br><br><br><br><h1><b>In contul Dvs. nu a fost adaugat nici un elev. Daca veti continua acest test, rezultatul obtinut nu va fi salvat in cont.</b></h1><br><br><br><br>');
              this.showErrorPopup(buttongroup, titlelabel, message, path);
              return;
            }
            else if (+this.kids[this.userAccount.lastUsedMember].class !== +this.customPathParams['class']) {
              const buttongroup = [{ label: this.translator.translate('idx', '*Sustine testul'), action: 1 }, { label: this.translator.translate('idx', '*Anuleaza'), action: 0 }];
              const titlelabel = this.translator.translate('idx', '*Atentionare!');
              const message = this.translator.translate
                ('idx', '*<br><br><br><br><h1><b>Elevul selectat in contul Dvs. are un nivel diferit de cel al testului. Daca veti continua acest test, rezultatul obtinut nu va fi salvat in cont.</b></h1><br><br><br><br>');
              this.showErrorPopup(buttongroup, titlelabel, message, path);
              return;
            }
            else if (this.kids.length > 1) {
              const lbl = this.translator.translate('idx', '*Selecteaza membrul familiei activ! Acest test este recomandat pentru varsta: ') +
                this.dataClass[this.customPathParams['class']].name +
                this.translator.translate('idx', '*Daca veti selecta un elev cu nivel diferit fata de cel al testului, rezultatul obtinut nu va fi salvat in cont!');
              this.modalCtrl.create({
                component: SwitchuserComponent,
                backdropDismiss: false,
                id: 'switchuser',
                cssClass: 'modal-vertical-halfscreen',
                componentProps: { style: 'kids', message: lbl }
              }).then(modalEl => {
                modalEl.present();
                return modalEl.onDidDismiss();
              }).then(resultData => {
                this.userAccount.lastUsedMember = +resultData.data;
                const upd = { lastUsedMember: +resultData.data };
                const paths = 'users/' + this.activeUser.auth.currentUser.uid + '/accountdata';
                this.updatedata(paths, upd);
                this.grabStudentResults();
                this.examService.grabTest(path, this);
              });
              return;
            }
            this.grabStudentResults();
          }
          this.examService.grabTest(path, this);
        }
        else {
          const buttongroup = [{ label: this.translatorService.translate('idx', '*Ok'), action: 0 }];
          const titlelabel = this.translatorService.translate('idx', '*Eroare.');
          const message = this.translatorService.translate('idx', '*Acest test se afla in acest moment in verificare. Va rugam incercati mai tarziu.');
          this.modalCtrl.create({
            component: GenericpopupComponent,
            backdropDismiss: false,
            id: 'invalidtest',
            cssClass: this.isDesktop ? 'modal-generic' : 'modal-fullscreen',
            componentProps: { title: titlelabel, body: message, buttons: buttongroup }
          }).then(modalEl => {
            modalEl.present();
            return modalEl.onDidDismiss();
          }).then(resultData => {
            if (this.userAccount.confirmed === true) {
              this.navCtrl.navigateRoot('tabs/tab1');

            }
            else {
              this.navCtrl.navigateRoot('tabs/tab4');
            }
          });
        }
      });

    }
  }
  public showUserAuthPopup(hrefpath) {
    const buttongroup = [{ label: this.translator.translate('idx', '*COPIAZĂ LINK'), action: -1 }];
    const titlelabel = this.translator.translate('idx', '*EROARE!');
    const message = this.translator.translate
      ('idx', '*<br><h1><b> Am întâmpinat o eroare! Există posibilitatea ca Dvs. să fi deschis link-ul din email în alt browser decât cel în care ați completat adresa de e-mail în platforma noastră. <br> Vă rugăm să apăsați pe butonul de mai jos pentru a salva link-ul și apoi să îl introduceți în pagina unde ați completat adresa în platforma noastră.</b></h1><br>');

    this.modalCtrl.create({
      component: GenericpopupComponent,
      backdropDismiss: false,
      id: 'invalidtest',
      cssClass: this.isDesktop ? 'modal-generic' : 'modal-fullscreen',
      componentProps: { title: titlelabel, body: message, buttons: buttongroup }
    }).then(modalEl => {
      modalEl.present();
      return modalEl.onDidDismiss();
    }).then(async resultData => {
      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(hrefpath);
        } catch (err) { }
      }
    });

  }
  public showErrorPopup(buttongroup, titlelabel, message, path) {
    this.modalCtrl.create({
      component: GenericpopupComponent,
      backdropDismiss: false,
      id: 'invalidtest',
      cssClass: this.isDesktop ? 'modal-generic' : 'modal-fullscreen',
      componentProps: { title: titlelabel, body: message, buttons: buttongroup }
    }).then(modalEl => {
      modalEl.present();
      return modalEl.onDidDismiss();
    }).then(resultData => {
      if (+resultData.data.data === 0) {
        this.navCtrl.navigateForward('tabs/tab1');
      }
      else {
        this.examService.grabTest(path, this);
      }
    });
  }
  public async grabStudentResults() {
    this.studentResults = null;
    const path = 'users/' + this.userAccount.uid + '/kids/' + this.userAccount.lastUsedMember + '/testresults/';
    await this.grabdata(path).then((data: any) => {
      if (data.data && data.data !== 'fail') {
        this.studentResults = data.data;
        console.log(this.studentResults);
      }
      this.grabStudentTests();
    });
  }
  public async grabCompetitionData() {
    const path = 'competition/structure/' + this.datalanguages[this.userAccount.languageid].shortval + '/' + this.kids[this.userAccount.lastUsedMember].class;
    await this.grabdata(path).then((data: any) => {
      this.allCompetitionStructure = data.data;
    });
  }
  public async grabCompetitionResults() {
    const path = 'users/' + this.userAccount.uid + '/kids/' +
      this.userAccount.lastUsedMember + '/testresults/competition/' +
      this.datalanguages[this.userAccount.languageid].shortval
      + '/' + this.kids[this.userAccount.lastUsedMember].class;
    await this.grabdata(path).then((data: any) => {
      if (data.data !== null) {
        this.allCompetitionResults = data.data;
      }
    });
  }
  public async grabAllTests() {
    const path = 'tests/structure/';
    await this.grabdata(path).then((data: any) => {
      this.allTests = data.data;
    });
  }
  public async grabStudentTests() {
    const uid = this.activeUser.auth.currentUser.uid;
    this.studentTests = [];
    for (const lang in this.datalanguages) {
      if (Object.prototype.hasOwnProperty.call(this.datalanguages, lang)) {
        const path = 'tests/structure/' + this.datalanguages[lang].shortval + '/' + this.kids[this.userAccount.lastUsedMember].class;
        await this.grabdata(path).then((data: any) => {
          if (data.data !== null) {
            for (const teacheruid in data.data) {
              if (Object.prototype.hasOwnProperty.call(data.data, teacheruid)) {
                for (const tests in data.data[teacheruid].tests) {
                  if (Object.prototype.hasOwnProperty.call(data.data[teacheruid].tests, tests)) {
                    const isResultsAvailable = this.checkResultsForTest(this.datalanguages[lang].shortval,
                      this.kids[this.userAccount.lastUsedMember].class, teacheruid, tests);
                    if (data.data[teacheruid].tests[tests].testconfirmed === true || data.data[teacheruid].tests[tests].testconfirmed === 'true') {
                      console.log(data.data[teacheruid].tests[tests].dateAdded);
                      if (data.data[teacheruid].tests[tests].dateAdded != '' || data.data[teacheruid].tests[tests].dateAdded != "undefined") {
                        this.studentTests.push({
                          testname: data.data[teacheruid].tests[tests].title,
                          langid: +lang, class: this.kids[this.userAccount.lastUsedMember].class,
                          testid: +tests, teacherpath: teacheruid, teachername: data.data[teacheruid].name,
                          teacherschool: data.data[teacheruid].unitate, resultsavailable: isResultsAvailable, dateAdded: data.data[teacheruid].dateAdded,
                          materie: +data.data[teacheruid].tests[tests].materie, testconfirmed: data.data[teacheruid].tests[tests].testconfirmed,
                          isCompetition: false
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        });
      }
    }
  }
  public checkResultsForTest(lang, classid, teacheruid, tests) {
    let resultsExist = false;
    if (this.studentResults &&
      this.studentResults[teacheruid] &&
      this.studentResults[teacheruid][lang] &&
      this.studentResults[teacheruid][lang][classid] &&
      this.studentResults[teacheruid][lang][classid][tests]
    ) {
      resultsExist = true;
    }
    return resultsExist;
  }
  public getResultsForTest(lang, classid, teacheruid, tests) {
    let resultsForTest;
    if (this.studentResults &&
      this.studentResults[teacheruid] &&
      this.studentResults[teacheruid][lang] &&
      this.studentResults[teacheruid][lang][classid] &&
      this.studentResults[teacheruid][lang][classid][tests]
    ) {
      resultsForTest = this.studentResults[teacheruid][lang][classid][tests];
    }
    return resultsForTest;
  }
  public startTest() {
    this.navCtrl.navigateForward('exam');
  }
  private async grabKids() {
    const uid = this.activeUser.auth.currentUser.uid;
    const path = 'users/' + uid + '/kids';
    await this.grabdata(path).then((data: any) => {
      if (data.data != null) {
        this.kids = data.data;
      }
    });
    if (this.customPath.length > 0) {
      this.parseCustomPath();
    }
    else {
      this.navCtrl.navigateForward('tabs/tab1');
    }
  }
  private async grabTeacherTests() {
    const uid = this.activeUser.auth.currentUser.uid;
    const path = 'users/' + uid + '/tests';
    this.teacherTests = [];
    await this.grabdata(path).then((data: any) => {
      if (data.data != null) {
        for (const key in this.dataClass) {
          if (Object.prototype.hasOwnProperty.call(this.dataClass, key)) {
            if (data.data.ro !== undefined && data.data.ro[key] !== undefined) {
              // eslint-disable-next-line @typescript-eslint/prefer-for-of
              for (let k = 0; k < data.data.ro[key].length; k++) {
                const testconfirmedval = data.data.ro[key][k].testconfirmed === undefined ? false : data.data.ro[key][k].testconfirmed;
                let dateAddedVal = "";
                if (data.data.ro[key][k].dateAdded != undefined) {
                  dateAddedVal = this.datePipe.transform(data.data.ro[key][k].dateAdded, 'dd MMM yyyy');

                  this.teacherTests.push({
                    testname: data.data.ro[key][k].title, langid: 0, class: +key, testid: k,
                    teacherpath: '', teachername: '', teacherschool: '', resultsavailable: false, dateAdded: dateAddedVal,
                    materie: data.data.ro[key][k].materie, testconfirmed: testconfirmedval,
                    isCompetition: false
                  });
                }

              }
            }
            if (data.data.uk !== undefined && data.data.uk[key] !== undefined) {
              // eslint-disable-next-line @typescript-eslint/prefer-for-of
              for (let k = 0; k < data.data.uk[key].length; k++) {
                this.teacherTests.push({
                  testname: data.data.uk[key][k].title, langid: 1, class: +key, testid: k,
                  teacherpath: '', teachername: '', teacherschool: '', resultsavailable: false, dateAdded: data.data.uk[key][k].dateAdded,
                  materie: data.data.uk[key][k].materie, testconfirmed: data.data.uk[key][k].testconfirmed,
                  isCompetition: false
                });
              }
            }
            if (data.data.hu !== undefined && data.data.hu[key] !== undefined) {
              // eslint-disable-next-line @typescript-eslint/prefer-for-of
              for (let k = 0; k < data.data.hu[key].length; k++) {
                this.teacherTests.push({
                  testname: data.data.hu[key][k].title, langid: 2, class: +key,
                  testid: k, teacherpath: '', teachername: '', teacherschool: '', resultsavailable: false, dateAdded: data.data.uk[key][k].dateAdded,
                  materie: data.data.hu[key][k].materie, testconfirmed: data.data.hu[key][k].testconfirmed,
                  isCompetition: false
                });
              }
            }
          }
        }
      }
    });
    if (this.customPath.length > 0) {
      this.parseCustomPath();
    }
    else {
      if (window.localStorage.getItem('portlanguage.shortval')) {
        this.cacheTest.testData.testname = window.localStorage.getItem('title');
        this.cacheTest.testData.langid = window.localStorage.getItem('portlanguage.id');
        this.cacheTest.testData.shortval = window.localStorage.getItem('portlanguage.shortval');
        this.cacheTest.testData.class = window.localStorage.getItem('portClass.id');
        this.cacheTest.testData.materie = window.localStorage.getItem('materie');
        this.cacheTest.questionsdata.q = []
        var qsize = +window.localStorage.getItem('questionsize');

        for (var i = 0; i < qsize; i++) {
          const questionvals = {
            id: i,
            label: window.localStorage.getItem('q' + i + "_label"),
            question: window.localStorage.getItem('q' + i + "question"),
            questionType: window.localStorage.getItem('q' + i + "questionType"),
            rightAnswer:  window.localStorage.getItem('q' + i + "rightAnswer"),
            points: window.localStorage.getItem('q' + i + "points"),
            answers: window.localStorage.getItem('q' + i + "answers")
          };
          this.cacheTest.questionsdata.q.push(questionvals);
        }
      }
      this.navCtrl.navigateForward('tabs/tab1');
    }
  }

  private async checkOverlay(type: string, path: string = '') {
    // eslint-disable-next-line prefer-const
    const msg = this.translator.translate('idx', '*Se încarcă datele!');
    if (this.counterOverlay === 1 && type === 'add') {
      this.loadingAsset = await this.loadingController.create({
        spinner: 'crescent',
        message: msg,
        translucent: true
      });
      this.loadingAsset.present();
    }
    else if (this.counterOverlay === 0) {
      this.loadingAsset.dismiss();
    }
  }
}
